import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { useMemo } from 'react';
import Image from 'next/image';
import { customImageLoader } from '@restworld/utils-common';
import { Title } from '../../';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var ImageGallery = function ImageGallery(_ref) {
  var images = _ref.images,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'full' : _ref$type,
      onClick = _ref.onClick;
  return type === 'full' ? /*#__PURE__*/_jsx(FullViewGallery, {
    images: images
  }) : /*#__PURE__*/_jsx(HalfViewGallery, {
    images: images,
    onClick: onClick
  });
};
export default ImageGallery; // --> types

// --> components --> full view
var FullViewGallery = function FullViewGallery(_ref2) {
  var images = _ref2.images;
  return /*#__PURE__*/_jsx(FullViewWrapper, {
    children: images !== null && images !== void 0 && images.length ? images.map(function (v) {
      return /*#__PURE__*/_jsx(ImageStyled, {
        width: 400,
        height: 400,
        alt: "alt",
        src: v
      }, v);
    }) : null
  });
}; // --> components --> half view


var HalfViewGallery = function HalfViewGallery(_ref3) {
  var images = _ref3.images,
      onClick = _ref3.onClick;
  var imagesEl = useMemo(function () {
    var initialImageEl = /*#__PURE__*/_jsx(ImageElement, {
      width: "full",
      imgSrc: images === null || images === void 0 ? void 0 : images[0]
    });

    var remainingImagesEl = images === null || images === void 0 ? void 0 : images.map(function (v, i, list) {
      if ((list === null || list === void 0 ? void 0 : list.length) - 1 >= 3) {
        var remainImagesLength = list.length - 5;
        if (i >= 0 && i < 3) return /*#__PURE__*/_jsx(ImageElement, {
          width: "half",
          imgSrc: v
        }, i);
        if (i === 3) return /*#__PURE__*/_jsxs(ImageElementWrapper, {
          href: "#!",
          width: "half",
          onClick: onClick,
          children: [/*#__PURE__*/_jsx(ImageStyled, {
            blurDataURL: "",
            fill: true,
            $customStyle: {
              "--tw-bg-opacity": "0.5"
            },
            alt: "gallery",
            loading: "lazy",
            src: v
          }), /*#__PURE__*/_jsx(CenterElement, {
            children: /*#__PURE__*/_jsx(Title, {
              content: "+".concat(remainImagesLength),
              fontSize: "small",
              textColor: "white"
            })
          })]
        }, i);
      }

      return null;
    });
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ImageElementMainWrapper, {
        children: initialImageEl
      }), /*#__PURE__*/_jsx(ImageElementMainWrapper, {
        children: remainingImagesEl
      })]
    });
  }, [images, onClick]);
  return /*#__PURE__*/_jsx(HalfViewMainWrapper, {
    children: /*#__PURE__*/_jsx(HalfViewSubWrapper, {
      children: imagesEl
    })
  });
}; // --> child components


var ImageStyled = /*#__PURE__*/_styled(function (props) {
  return /*#__PURE__*/_jsx(Image, _objectSpread({
    loader: customImageLoader
  }, props));
}).withConfig({
  displayName: "image-gallery__ImageStyled",
  componentId: "sc-355b1x-0"
})(["", " ", "}"], {
  "display": "block",
  "height": "100%",
  "width": "100%",
  "borderRadius": "0.5rem",
  "objectFit": "cover",
  "objectPosition": "center"
}, function (_ref4) {
  var $customStyle = _ref4.$customStyle;
  return $customStyle;
});

var FullViewWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "image-gallery__FullViewWrapper",
  componentId: "sc-355b1x-1"
})({
  "display": "flex",
  "height": "100%",
  "flexDirection": "column",
  "gap": "0.5rem",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem"
});

var HalfViewMainWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "image-gallery__HalfViewMainWrapper",
  componentId: "sc-355b1x-2"
})({
  "@media (min-width: 25.75rem)": {
    "paddingLeft": "0px",
    "paddingRight": "0px"
  }
});

var HalfViewSubWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "image-gallery__HalfViewSubWrapper",
  componentId: "sc-355b1x-3"
})({
  "display": "flex",
  "height": "100%",
  "flexWrap": "wrap"
});

var CenterElement = function CenterElement(_ref5) {
  var children = _ref5.children;
  return /*#__PURE__*/_jsx(_StyledDiv, {
    children: children
  });
};

var ImageElement = function ImageElement(_ref6) {
  var imgSrc = _ref6.imgSrc,
      width = _ref6.width;
  return /*#__PURE__*/_jsx(ImageElementWrapper, {
    width: width,
    children: imgSrc ? /*#__PURE__*/_jsx(ImageStyled, {
      height: 400,
      width: 400,
      alt: "",
      src: imgSrc
    }) : null
  });
};

var ImageElementMainWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "image-gallery__ImageElementMainWrapper",
  componentId: "sc-355b1x-4"
})({
  "display": "flex",
  "width": "50%",
  "flexWrap": "wrap"
});

var ImageElementWrapper = /*#__PURE__*/_styled.a.withConfig({
  displayName: "image-gallery__ImageElementWrapper",
  componentId: "sc-355b1x-5"
})(["", " ", ""], {
  "position": "relative",
  "padding": "0.25rem"
}, function (_ref7) {
  var width = _ref7.width;
  return widthMap[width];
}); // --> constants


var widthMap = {
  full: {
    "width": "100%"
  },
  half: {
    "width": "50%"
  }
};

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "image-gallery___StyledDiv",
  componentId: "sc-355b1x-6"
})({
  "position": "absolute",
  "top": "50%",
  "left": "50%",
  "zIndex": "50",
  "marginRight": "-50%",
  "--tw-translate-x": "-50%",
  "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
  "--tw-translate-y": "-50%"
});